/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['require',
    'jquery',
    'knockout',
    '../../appContext',
    '../../utils/tools',
    'raw-loader!./dvpinpoint.html',
    './dvpinpoint.css',
],
function (require, $, ko, app, tools, componentTemplate) {
    "use strict";

    var dvPinpoint = {};
    dvPinpoint.searchText = "";

    dvPinpoint.componentName = "";

    //create the most recent items with up to 20 values...MD
    dvPinpoint.recentList = new Array();

    /**
     * Updates/adds the specific entity in the recent list
     * @param {Object|Array} entity - The entity(s) to update in the recent list
     * @param {Boolean} [addNewEntity = false] - Adds the entity to the recent list if true
     * @returns {Array} The dvPinpoint's recent list array
    */
    dvPinpoint.updateRecentList = function(entity, addNewEntity = false){

        let updateEntity = (ent) => {
            //do not include new objects that have not been saved yet or have neen cancelled..MD
            if (ent != null && ent._State != null && ent._State != app.dv.types.EntityStates.NewObject) {
                if (dvPinpoint.recentList.length > 0) {
                    // make a copy of the recent list
                    if (ent != null && ent.UID != null) {
                        let newList = dvPinpoint.recentList;
                        for (var i = 0, ilimit = dvPinpoint.recentList.length; i < ilimit; i++) {
                            let p = dvPinpoint.recentList[i];
                            if (p != null && p.UID !== null && p.UID == ent.UID) {
                                //remove duplicate and add the new item
                                newList.splice(i, 1);
                            }
                        }
                        dvPinpoint.recentList = newList;
                    }

                }
                //if addNewEntity is true we are adding a new entity
                if (addNewEntity) {
                    dvPinpoint.recentList.splice(0, 0, ent);
                }

                //before returning the list, limit the array to 20 items
                if (dvPinpoint.recentList.length > 20) {
                    dvPinpoint.recentList.length = 20;
                }
            }
        };

        if (Array.isArray(entity)) {
            entity.forEach((e) => {
                updateEntity(e);
            })
        }
        else {
            updateEntity(entity);
        }

        return dvPinpoint.recentList;
    }

    function componentViewModel(params) {
        var vm = {};

        //Variable holding if we have already created the left canvas;
        //vm.canvasCreated = vm.classObject().canvasCreated;

        //Get model object
        vm.classObject = params.objModel;

        //Wire up properties to model object
        vm.checkClose = vm.classObject().checkClose;

        //These are the visibility variables for the left and right panels
        vm.showLeftCont = vm.classObject().showLeftCont;
        vm.showRightCont = vm.classObject().showRightCont;

        //Visibility of the open icon for the view.
        vm.showOpenIcon = vm.classObject().showOpenIcon;

        //Visibility of the clone icon...eg
        vm.showCloneIcon = vm.classObject().showCloneIcon;

        //Visibiliy of the delete icon
        vm.showDeleteIcon = vm.classObject().showDeleteIcon;

        //Visibility of Where Used panel
        vm.showWhereUsed = vm.classObject().showWhereUsed;

        //Visibility of the delete panel
        vm.showDeletePanel = vm.classObject().showDeletePanel;

        //This is the variable that contains the search text
        vm.searchAreaInput = vm.classObject().searchAreaInput;

        //This is the function that is called when the user types in the search area
        vm.searchList = vm.classObject().searchList;

        //This is the array that holds up to 20 most recent used entities..MD

        vm.recentList = vm.classObject().recentList;

        //This is the variable that holds the name of the control type on the right panel (View, Record Type...)
        vm.rightContType = vm.classObject().rightContType;

        //Variables holding the entity's id and uid
        vm.rUIDLabel = vm.classObject().rUIDLabel;
        vm.rIDLabel = vm.classObject().rIDLabel;

        //Variable holding the entity title, name, and hint
        vm.titleAreaInput = vm.classObject().titleAreaInput;
        vm.nameAreaInput = vm.classObject().nameAreaInput;
        vm.hintAreaInput = vm.classObject().hintAreaInput;
        vm.tagsHTML = vm.classObject().tagsHTML;

        //Variable holding the entity title, name, and hint labels (for use on expressions which use syntax etc.)...TD
        vm.titleLabel = vm.classObject().titleLabel;
        vm.nameLabel = vm.classObject().nameLabel;
        vm.hintLabel = vm.classObject().hintLabel;
        vm.tagLabel = vm.classObject().tagLabel;

        //Variables determining if the entity title, name, and hint fields should be shown for the entity...AM
        vm.showTitle = vm.classObject().showTitle;
        vm.showName = vm.classObject().showName;
        vm.showHint = vm.classObject().showHint;
        vm.showTags = vm.classObject().showTags;

        //Action that happens when you click the open button
        vm.openEntity = vm.classObject().openEntity;

        //Action that happens when you click the edit button
        vm.editEntity = vm.classObject().editEntity;

        //Action to copy an entity
        vm.copyEntity = vm.classObject().copyEntity;

        //Action to delete an entity
        vm.checkDeleteEntity = vm.classObject().checkDeleteEntity;

        //When the user confirms to delete the entity;
        vm.deleteEntity = vm.classObject().deleteEntity;

        //Action to open the whereUsed panel
        vm.whereUsedClick = vm.classObject().whereUsedClick;

        //Action to close the whereUsed Panel
        vm.goBackClick = vm.classObject().goBackClick;

        //functions for copying the ID and UID fields to the clipboard.
        vm.copyUID = vm.classObject().copyUID;
        vm.copyID = vm.classObject().copyID;

        //Bind the escape key to close the search panel
        $("#pinpointBox").keyup(function (event) {
            var KE = zebra.ui.KeyEvent;
            switch(event.keyCode){
                case KE.LEFT:
                case KE.RIGHT:
                case KE.CTRL:
                case KE.ALT:
                case KE.CAPS:
                case KE.CMD:
                case KE.RIGHTCMD:
                case KE.PAGEUP:
                case KE.PAGEDOWN:
                case KE.HOME:
                case KE.END:
                case KE.INSERT:
                case KE.SHIFT:
                    event.stop = true;
                    break;
                case KE.ESCAPE:
                    vm.classObject().checkClose();
                    break;
                case KE.ENTER:
                    let leftCanvas = vm.classObject().leftCanvas;
                    if(leftCanvas != null) {
                        //Detect the entity type
                        //If it is a form, the enter key should act as follows:
                        //     Enter - Opens the form
                        //     Shift + Enter - Edits the form
                        //If it is any other entity, the enter key should act as follows:
                        //     Enter - Edits the entity
                        let obj = leftCanvas.refControls.gpList.getValue();
                        if (obj != null && obj.src != null) {
                            switch (obj.src.clientProperties.entityType){
                                case app.dv.types.EntityTypes.View:
                                    //Add a shift case for editing the form.
                                    //Show the actual form on enter.
                                    if(event.shiftKey == true){
                                        vm.classObject().editEntity();
                                    }
                                    else{
                                        vm.classObject().openEntity();
                                    }
                                    break;
                                default:
                                    //This is all other entities, edit the entity on enter.
                                    vm.classObject().editEntity();
                            }
                        }
                        else if (obj && obj.typeName == 'zebra.data.GroupedListModel.GroupModel') {
                            //We have a view all item, expand the list...KB
                            vm.classObject().viewAllPressed();
                        }
                    }
                    event.stop = true;
                    break;
                case KE.UP:
                case KE.DOWN:
                    event.code = event.keyCode;
                    event.stop = true;
                    vm.classObject().leftCanvas.refControls.gpList.keyPressed(event);
                    break;
                default:
                    break;
            }
            return;
        });

        //this is to prevent the search field from going to the beginning and end of the field when up and down is pressed
        $("#pinpointBox").keydown( function(event) {
            if (event.keyCode ===  zebra.ui.KeyEvent.UP || event.keyCode === zebra.ui.KeyEvent.DOWN)
            {
                return false;
            }
        });

        return vm;
    }

    dvPinpoint.component = {};
    dvPinpoint.component.viewModel = componentViewModel;
    dvPinpoint.component.template = componentTemplate.default;

    dvPinpoint.model = function () {
        var m = {},
            positioned = false;

        m.componentName = ko.observable(dvPinpoint.componentName);
        m.boundNameProperty = ko.observable(m.componentName());

        //Visibility of the entire control
        m.boundShowProperty = ko.observable(false);

        //This is the variable that contains the search text
        m.searchAreaInput = ko.observable("");

        //This is the variable that holds the name of the control type on the right panel (View, Record Type...)
        m.rightContType = ko.observable("");

        //variables holding the entities id and uid
        m.rUIDLabel = ko.observable("");
        m.rIDLabel = ko.observable("");

        //Variables holding the entity title, name, and hint
        m.titleAreaInput = ko.observable("");
        m.nameAreaInput = ko.observable("");
        m.hintAreaInput = ko.observable("");
        m.tagsHTML = ko.observable("");

        //Holder for the entity used in the deletion process
        m.entity = ko.observable();

        //Variables holding the entity title, name, and hint labels (custom expression will change these to syntax keywords etc)...TD
        m.titleLabel = ko.observable("Title");
        m.nameLabel = ko.observable("Name");
        m.hintLabel = ko.observable("Description");
        m.tagLabel = ko.observable("Tags");

        //Variables determining if the entity title, name, and hint fields should be shown for the entity...AM
        m.showTitle = ko.observable(true);
        m.showName = ko.observable(true);
        m.showHint = ko.observable(true);
        m.showTags = ko.observable(false);

        m.htmlId = "Pinpoint";
        m.displayLimit = 5;

        //group list view all reference
        m.viewAllEntity = null;

        //Visibility of the left and right controls
        m.showLeftCont = ko.observable(false);
        m.showRightCont = ko.observable(false);

        //Visibility of the where used and delete panels
        m.showWhereUsed = ko.observable(false);
        m.showDeletePanel = ko.observable(false);

        //visibility of open icon (view)
        m.showOpenIcon = ko.observable(false);
        m.showDeleteIcon = ko.observable(false);
        m.showCloneIcon = ko.observable(false);

        //If we are replacing the finder, this will keep open the panel even when no search results are displayed.
        m.keepOpen = ko.observable(false);

        //use this variable to check if the last search is empty, used to prevent list flashing when continuously searching against no results...TD
        m.lastSearchEmpty = false;

        //action that happens when you click the open icon or press shift+enter.
        //If the entity is not a view, it won't have a ViewID and will just null out.
        m.openEntity = function(){
            var obj, entity, selected;
            if(m.leftCanvas != null){
                obj = m.leftCanvas.refControls.gpList.getValue();
                //only want to open if we are not on a group header
                if(obj != null && obj.src != null){
                    entity = obj.src;
                    if(entity.ViewID == null){
                        //this is not a view, don't close the search
                        //If you're trying to open a non-Form entity, just edit it...KB
                        return m.editEntity();
                    }
                    m.checkClose(true);
                    // need to get the latest copy from the cache due to syncing issues.
                    selected = app.dv.cache.views.allViews.getVal(entity.ViewID);
                    if (selected != null) {
                       // add to the top of the recent items list...MD
                        dvPinpoint.updateRecentList(selected, true);
                        //Check to see if designer mode is active, if so we want to attach a designer to this view being opened...TD
                        if (app.designer.designerActive) {
                            app.dv.addNewView(selected).then(() => {
                                let viewMVC = app.dv.cache.mvcs.getVal(selected.ViewID);
                                if (viewMVC.activeDesigner == null) {
                                    (new app.designer.FormDesigner()).attachDesigner(viewMVC);
                                }
                            });
                        }
                        else {
                            app.dv.addNewView(selected);
                        }
                    }

                }
            }

        };

        /*This function will open the editor for the specified entity type
        * @param switchTab: if the user pressed 'where used' we will pass a true value into the editor which will auto-open the where-used tab
        * */
        m.editEntity = function(switchTab){
            var obj, entity, selected, entityType, entityCheck;
            if(m.leftCanvas != null) {
                obj = m.leftCanvas.refControls.gpList.getValue();
                //We don't want to close if we clicked on the group header.
                if (obj != null && obj.src != null) {
                    m.checkClose(true);
                    entity = obj.src;
                    entityType = entity.clientProperties.entityType;

                     //updated recent item list..MD
                    dvPinpoint.updateRecentList(entity, true);

                    switch (entityType) {
                        case app.dv.types.EntityTypes.View:

                            //Open the form comp editor rail...eg
                            let formEditor = new api.designer.editor.FormCompEditor(entity.ViewID);

                            //Expand the whereUsed section for a form if we get to it from pinpoint this way...BC
                            formEditor.formComponent.groups.whereUsed.expand();
                            app.designer.railControl.beginEdit(entity, formEditor);
                            break;
                        case app.dv.types.EntityTypes.RecordType:
                            //Show the table editor in the rail...eg
                            let tableEditor = new api.designer.editor.TableEditor(entity);
                            app.designer.railControl.beginEdit(entity, tableEditor);
                            break;
                        case app.dv.types.EntityTypes.Style:
                            entityCheck = app.dv.cache.styles.allStyles.getVal(entity.StyleID);
                            //only edit a style if it exists in the cache
                            if(entityCheck != null) {
                                app.designer.editors.editStyle(entity.StyleID, function (editEntity, editAspect) {
                                    //This is a callback
                                }, switchTab);
                            }
                            break;
                        case app.dv.types.EntityTypes.Tag:
                            app.designer.editors.editTag(entity.TagID, function(editEntity, editAspect) {
                                //This is a callback
                            });
                            break;
                        case app.dv.types.EntityTypes.ValueStatus:
                            //Show the status editor in the rail...eg
                            let statusEditor = new api.designer.editor.StatusEditor(entity.ValueStatusID);
                            app.designer.railControl.beginEdit(entity, statusEditor);
                            break;
                        case app.dv.types.EntityTypes.Package:
                            entityCheck = app.designer.monitor.openEditors.Values.find(c => c.entityKeyName === "PackageID");
                           //Only edit a package if no other package editor is open.
                            if(entityCheck == null) {
                                app.designer.editors.editPackage(entity.PackageID, function (editEntity, editAspect) {
                                    //This is a callback
                                });
                            }
                            break;
                        case app.dv.types.EntityTypes.Property:
                            //Open the column editor rail...eg
                            let columnEditor = new api.designer.editor.ColumnEditor(entity.PropertyID);
                            app.designer.railControl.beginEdit(entity, columnEditor);
                            break;
                        case app.dv.types.EntityTypes.SecurityGroup:
                            //Show the security group editor in the rail...eg
                            let securityGroupEditor = new api.designer.editor.SecurityGroupEditor(entity.SecurityGroupID);
                            app.designer.railControl.beginEdit(entity, securityGroupEditor);
                            break;
                        case app.dv.types.EntityTypes.Expression:
                            app.designer.editors.editCustomFunction(entity.ExtensionID, function (editEntity, editAspect) {
                                //This is a callback
                            });
                            break;
                        case app.dv.types.EntityTypes.Action:
                            app.designer.editors.editCustomAction(entity.ExtensionID, function (editEntity, editAspect) {
                                //This is a callback
                            });
                            break;
                        case app.dv.types.EntityTypes.Endpoint:
                            app.designer.editors.editCustomEndpoint(entity.ExtensionID, function (editEntity, editAspect) {
                                //This is a callback
                            });
                        default:
                            m.rIDLabel("");
                    }
                }
                else{
                    m.viewAllPressed();
                }
            }
        };

        m.copyEntity = function(){
            //Code for the copied Entity
            var obj, entity, entityType, selected;
            if(m.leftCanvas != null) {
                obj = m.leftCanvas.refControls.gpList.getValue();
                //only want to open if we are not on a group header
                if (obj != null && obj.src != null) {
                    entity = obj.src;
                    entityType = entity.clientProperties.entityType;

                    switch (entityType) {
                        case app.dv.types.EntityTypes.View:
                            if (entity.ViewID == null) {
                                //this is not a view, don't close the search
                                app.browser.notifier.showToast("There has been an error copying the form", 3000, 0);
                                break;
                            }
                            //copy the View and save it and reopen for edit...MD
                            //pass current view definition and column properties to new copied view and update add tags...MD
                            //clone existing view, do not set default controls

                            //Close the finder...eg
                            m.checkClose(true);

                            //Copy the view...eg
                            app.designer.factory.cloneView(entity, function(newView, result){
                                if (result == true) {
                                    //updated recent item list..MD
                                    dvPinpoint.updateRecentList(newView, true);

                                    //Open the form comp editor rail...eg
                                    let formEditor = new api.designer.editor.FormCompEditor(newView.ViewID)
                                    app.designer.railControl.beginEdit(newView, formEditor);
                                } else {
                                    //display  toast with  error message and return null...MD
                                    app.browser.notifier.showToast("There has been an error copying the form.", 3000, 0);
                                }
                            });

                            break;
                        case app.dv.types.EntityTypes.Style:
                            //Close the finder...eg
                            m.checkClose(true);

                            //Copy the style...eg
                            app.designer.factory.cloneStyle(entity);
                            dvPinpoint.updateRecentList(entity, true);

                            break;

                        case app.dv.types.EntityTypes.Action:
                            // close the finder
                            m.checkClose(true);

                            // copy the action
                            app.designer.factory.cloneAction(entity);
                            dvPinpoint.updateRecentList(entity, true);

                            break;

                        default:
                            //Do nothing because the entity is not valid...eg
                    }


                }
            }
        };

        m.goBackClick = function(){
            m.showWhereUsed(false);
            m.showDeletePanel(false);
        };

        m.deleteEntity = function(){
            var entity = m.entity(),
                l =  m.leftCanvas.refControls.gpList,
                et = entity.clientProperties.entityType,
                offset = l.selectedIndex;
            //attempt to re-select near where the user was
            function reSelect(off){
                if(l.model.d.length > 0){
                    var md = l.model.d;
                    if(md[off] != null && md[off].typeName != "zebra.data.GroupedListModel.GroupModel"){
                        //attempt to select the same spot which will update the right panel
                        l.select(off)
                    }
                    else {
                        //start heading up in the list.
                        while(md[off] != null && md[off].typeName == "zebra.data.GroupedListModel.GroupModel"){
                            off--;
                            if(off <= 0){
                                //do nothing, just return;
                                return;
                            }
                        }
                        l.select(off)
                    }
                }
                else{
                    m.showLeftCont(false);
                    m.showRightCont(false);
                }
            }

            // close out any rail or window editors that deal with the entity being deleted.
            app.designer.utils.checkDesignerRailsForDelete(entity);
            app.designer.utils.checkDesignerWindowsForDelete(entity);

            switch (et) {
                case app.dv.types.EntityTypes.View:
                    //Delete the form
                    app.designer.deleteForm(entity).then((result) => {
                        if (result === true) {
                            //The form was removed, reset search...eg
                            m.performSearch(m);
                            reSelect(offset);
                            m.entity(null);
                        }
                    });
                    break;
                case app.dv.types.EntityTypes.RecordType:
                    app.designer.deleteTable(entity).then((result) => {
                        if (result === true) {
                            //The form was removed, reset search...eg
                            m.performSearch(m);
                            reSelect(offset);
                            m.entity(null);
                        }
                    });
                    break;
                case app.dv.types.EntityTypes.Style:
                    //Deletes need to flag the core cached entity for delete and pass it along...EK
                    var styleFromCache = app.dv.cache.styles.allStyles.getVal(entity.StyleID);

                    styleFromCache._State = app.dv.types.EntityStates.Deleted;           //Mark this view for deletion in the cache so we know that it needs to be removed... and save...EK
                    entity._State = app.dv.types.EntityStates.Deleted;   //Mark the actual edit view for deletion for the save request...EK

                    app.designer.saveEntityToServer([entity], "StyleID", app.dv.services.endpoints.saveStyles, app.dv.cache.styles.allStyles, function (success) {
                        //updated recent item list..MD
                        dvPinpoint.updateRecentList(entity);

                        m.performSearch(m);
                        reSelect(offset);
                        m.entity(null);
                    });
                    break;
                case app.dv.types.EntityTypes.Tag:
                    //Deletes need to flag the core cached entity for delete and pass it along...EK
                    var tagFromCache = app.dv.cache.tags.allTags.getVal(entity.TagID);

                    tagFromCache._State = app.dv.types.EntityStates.Deleted;           //Mark this view for deletion in the cache so we know that it needs to be removed... and save...EK
                    entity._State = app.dv.types.EntityStates.Deleted;   //Mark the actual edit view for deletion for the save request...EK

                    app.designer.saveEntityToServer([entity], "TagID", app.dv.services.endpoints.saveTags, app.dv.cache.tags.allTags, function (success) {
                        //updated recent item list..MD
                        dvPinpoint.updateRecentList(entity);
                        m.performSearch(m);
                        reSelect(offset);
                        m.entity(null);
                    });
                    break;
                case app.dv.types.EntityTypes.Package:
                    //Deletes need to flag the core cached entity for delete and pass it along...EK
                    let packageFromCache = app.dv.cache.packages.allPackages.getVal(entity.PackageID);

                    packageFromCache._State = app.dv.types.EntityStates.Deleted;           //Mark this package for deletion in the cache so we know that it needs to be removed... and save...EK
                    entity._State = app.dv.types.EntityStates.Deleted;   //Mark the package entity for deletion for the save request...EK

                    app.designer.saveEntityToServer([entity], "PackageID", app.dv.services.endpoints.savePackages, app.dv.cache.packages.allPackages, (success) => {
                        //updated recent item list..MD
                        dvPinpoint.updateRecentList(entity);
                        m.performSearch(m);
                        reSelect(offset);
                        m.entity(null);
                    });
                    break;
                case app.dv.types.EntityTypes.Action:
                    //Deletes need to flag the core cached entity for delete and pass it along...EK
                    var actionFromCache = app.dv.cache.extensions.allActions.getVal(entity.ExtensionID);

                    actionFromCache._State = app.dv.types.EntityStates.Deleted;           //Mark this view for deletion in the cache so we know that it needs to be removed... and save...EK
                    entity._State = app.dv.types.EntityStates.Deleted;   //Mark the actual edit view for deletion for the save request...EK

                    app.designer.saveEntityToServer(entity, "ExtensionID", app.dv.services.endpoints.saveExtensions, app.dv.cache.extensions.allActions, function (success) {
                        //update recent List on pinPoint Search
                        dvPinpoint.updateRecentList(entity);
                        app.dv.cache.extensions.allActions.remove(entity);
                        app.dv.cache.extensions.registeredActions.remove(entity);
                        //If the editor is open, force it to close...KB
                        app.designer.monitor.openEditors.Values.forEach((editor) => {
                            if (editor.editEntity.UID == entity.UID) {
                                editor.closeEditor();
                            }
                        });
                        m.performSearch(m);
                        reSelect(offset);
                        m.entity(null);
                    });
                    break;

                case app.dv.types.EntityTypes.Property:
                    //deletes need to flag the core cached entity for deleted properties and pass it along
                    var propertyFromCache = app.dv.cache.properties.allProperties.getVal(entity.PropertyID);
                    propertyFromCache._State = app.dv.types.EntityStates.Deleted;
                    entity._State = app.dv.types.EntityStates.Deleted;
                    //search for the property in the category client properties in clientProperties.Parent.clientProperties...MD
                    if (entity.clientProperties.Parent != null && entity.clientProperties.Parent.clientProperties != null){
                        var prop = entity.clientProperties.Parent.clientProperties.childProperties.where(function (p) { return p.UID == entity.UID; }).first();
                        entity.clientProperties.Parent.clientProperties.childProperties.remove(prop);
                    }
                    app.designer.saveEntityToServer([entity], "PropertyID", app.dv.services.endpoints.saveProperties, app.dv.cache.properties.allProperties, function (success) {
                        app.dv.cache.properties.allProperties.remove(entity);
                        //updated recent item list..MD
                        dvPinpoint.updateRecentList(entity);
                        m.performSearch(m);
                        reSelect(offset);
                        m.entity(null);
                    });


                    break;

                case app.dv.types.EntityTypes.Endpoint:
                    //Deletes need to flag the core cached entity for delete and pass it along...EK
                    let endpointFromCache = app.dv.cache.extensions.allCustomEndpoints.getVal(entity.ExtensionID);

                    //Mark this view for deletion in the cache so we know that it needs to be removed... and save...EK
                    endpointFromCache._State = app.dv.types.EntityStates.Deleted;
                    //Mark the actual edit view for deletion for the save request...EK
                    entity._State = app.dv.types.EntityStates.Deleted;

                    // We are not going to register the endpoint here so that designers are not confused since endpoint entities will not be pulled down by non-designers.
                    // // unregister the endpoint so we can delete it.
                    // app.dv.cache.extensions.unregisterEndpoint(entity);

                    app.designer.saveEntityToServer(entity, "ExtensionID", app.dv.services.endpoints.saveExtensions, app.dv.cache.extensions.allCustomEndpoints, function (success) {
                        //update recent List on pinPoint Search
                        dvPinpoint.updateRecentList(entity);
                        app.dv.cache.extensions.allCustomEndpoints.remove(entity);
                        //If the editor is open, force it to close...KB
                        app.designer.monitor.openEditors.Values.forEach((editor) => {
                            if (editor.editEntity.UID === entity.UID) {
                                editor.closeEditor();
                            }
                        });
                        m.performSearch(m);
                        reSelect(offset);
                        m.entity(null);
                    });
                    break;

                default:
                    m.goBackClick()

            }
        };

        m.whereUsedClick = function(){
            m.editEntity(true);
        }

        m.checkDeleteEntity = function() {
            var obj, entity, selected, entityType, whereUsedPlaces;
            if (m.leftCanvas != null) {
                obj = m.leftCanvas.refControls.gpList.getValue();
                //We don't want to close if we clicked on the group header.
                if (obj != null && obj.src != null) {
                    entity = obj.src;
                    entityType = entity.clientProperties.entityType;

                    switch (entityType) {
                        case app.dv.types.EntityTypes.View:
                            whereUsedPlaces = app.designer.whereUsed.viewWhereUsed(entity);
                            if (whereUsedPlaces != null && whereUsedPlaces.length > 0) {
                                m.showWhereUsed(true);
                                return;
                            }
                            else {
                                m.showDeletePanel(true);
                                m.entity(entity);
                            }
                            break;
                        case app.dv.types.EntityTypes.RecordType:
                            whereUsedPlaces = app.designer.whereUsed.recordTypeWhereUsed(entity);
                            if (whereUsedPlaces != null && whereUsedPlaces.length > 0) {
                                m.showWhereUsed(true);
                                return;
                            }
                            else {
                                m.showDeletePanel(true);
                                m.entity(entity);
                            }
                            break;
                        case app.dv.types.EntityTypes.Style:
                            whereUsedPlaces = app.designer.whereUsed.styleWhereUsed(entity);
                            if (whereUsedPlaces != null && whereUsedPlaces.length > 0) {
                                m.showWhereUsed(true);
                                return;
                            }
                            else {
                                m.showDeletePanel(true);
                                m.entity(entity);
                            }
                            break;
                        case app.dv.types.EntityTypes.Property:
                            whereUsedPlaces = app.designer.whereUsed.propertyWhereUsed(entity);
                            if (whereUsedPlaces != null && whereUsedPlaces.length > 0) {
                                m.showWhereUsed(true);
                                return;
                            }
                            else {
                                m.showDeletePanel(true);
                                m.entity(entity);
                            }

                            break;
                        case app.dv.types.EntityTypes.Tag:
                            whereUsedPlaces = entity.clientProperties.taggedEntities;
                            if (whereUsedPlaces != null && whereUsedPlaces.count() != 0) {
                                m.showWhereUsed(true);
                                return;
                            }
                            else {
                                m.showDeletePanel(true);
                                m.entity(entity);
                            }
                            break;
                        case app.dv.types.EntityTypes.Package:
                            //We do not check where used for packages...AM
                            m.showDeletePanel(true);
                            m.entity(entity);
                            break;
                        case app.dv.types.EntityTypes.Action:
                            //We do not check where used for custom actions...KB
                            m.showDeletePanel(true);
                            m.entity(entity);
                            break;
                        case app.dv.types.EntityTypes.Endpoint:
                            //We do not check where used for custom endpoints.
                            m.showDeletePanel(true);
                            m.entity(entity);
                            break;
                        default:
                            break;

                    }

                }
            }
            return;
        }

        m.viewAllPressed = function(){
            if(m.leftCanvas != null) {
                var listCont = m.leftCanvas.refControls.gpList, listObj = listCont.getValue();
                if (listObj != null && listObj.typeName == 'zebra.data.GroupedListModel.GroupModel' && listObj.rowCount > m.displayLimit) {
                    if (m.viewAllEntity == null) {
                        listCont.viewAllEntity = m.viewAllEntity = listObj.displayText.toLowerCase();
                    }
                    else {
                        listCont.viewAllEntity = m.viewAllEntity = null;
                    }

                    m.performSearch(m);
                    if (m.leftCanvas.refControls.gpList.model.count() > 0) {
                        //0 will be the group header, 1 will be the first item.
                        m.leftCanvas.refControls.gpList.$select(1);
                        m.leftCanvas.refControls.gpList.position.setOffset(0);
                    }
                }
            }
        }

        m.copyUID = function(){
            tools.copyToClipboard(m.rUIDLabel());
        };

        m.copyID = function(){
            tools.copyToClipboard(m.rIDLabel());
        };

        m.leftCanvas = null;

        var listening = false;

        m.htmlWindowResize = function (x, y) {
            if (m.canvas != null && m.src != null) {
                var workarea = document.getElementById("Pinpoint"),
                    h = window.innerHeight, w = window.innerWidth;

                workarea.style.opacity = 1;
                workarea.style.left = x + "px";
                workarea.style.top = y + "px";
            }
        };

        /*This function is the main function for showing the pinpoint search.
        * If there is text in the search area, it will also show the left panel.
        * @param keepOpen - if we are using it from the finder click, keep the panels open if results exist.
        * */
        m.show = function (keepOpen) {
            m.keepOpen(keepOpen);
            m.boundShowProperty(true);
            if(dvPinpoint.searchText.length > 0  || keepOpen == true){
                setTimeout(function(){
                    //m.showLeftCont(true);
                    //m.showLeftCanvas();
                    m.searchAreaInput(dvPinpoint.searchText)
                    var event = {};
                    m.searchList(null, event);
                }, 5);
            }
            if (listening == false) {
                if (window.addEventListener) {
                    window.addEventListener("resize", m.htmlWindowResize);
                }
                else {
                    window.attachEvent("resize", m.htmlWindowResize);
                }
                listening = true;
            }

            m.showTimeout = setTimeout(function (model){
                m.showTimeout = 0;
                $("#pinpointBox").focus();
                //Yes this is a double timeout, but it works...BC
                m.showTimeout2 = setTimeout(function(model){
                    $("#pinpointBox").focus();
                }, 5, m);
            }, 20, m);

        };

        // this function builds the groupedList control for search...TD
        m.showLeftCanvas = function () {
            m.showLeftCont(true);
            var canvasElement = $('#pinpointLeftContCanvas')[0];
            m.leftCanvas = zebra.ui.$detectZCanvas(canvasElement);
            if (m.leftCanvas == null) {
                m.leftCanvas = new zebra.ui.zCanvas('pinpointLeftContCanvas');

                m.leftCanvas.refControls = {};

                var rootPanel = m.leftCanvas.root,
                    generalPanel = new zebra.ui.Panel(),
                    groupedList = new zebra.data.GroupedListModel(),
                    gpList = new zebra.ui.GroupedList(groupedList),
                    scrollPan = new zebra.ui.dvScrollPan(gpList);

                gpList.viewAllEntity = m.viewAllEntity;

                rootPanel.setLayout(new zebra.layout.BorderLayout());
                generalPanel.setLayout(new zebra.layout.BorderLayout());
                generalPanel.setBackground('#e0e7ea');
                generalPanel.setPreferredSize(m.leftCanvas.width, m.leftCanvas.height);
                scrollPan.setPreferredSize(m.leftCanvas.width, m.leftCanvas.height);
                scrollPan.setAutoHide(true);
                gpList.setPreferredSize(m.leftCanvas.width, -1);

                //remove all padding and borders...TD
                rootPanel.setPadding(0);
                rootPanel.setBorder(null);
                generalPanel.setPadding(0);
                generalPanel.setBorder(null);
                scrollPan.setPadding(0);
                scrollPan.setBorder(null);
                gpList.setPadding(0);
                gpList.setBorder(null);

                //grab ref controls...TD
                m.leftCanvas.refControls.groupedList = groupedList;
                m.leftCanvas.refControls.gpList = gpList;
                m.leftCanvas.refControls.scrollPan = scrollPan;

                // set up handling of event
                gpList.bind("itemSelected", function (source, prev) {
                    //TODO: the item is selected, it will be source.getSelected();
                    var obj = source.getValue();
                    if(obj != null){
                        m.setRightPanel(obj.src);
                        $("#pinpointBox").focus();
                    }

                    var itm = -1;
                    if(source.lastEvent != null){
                        itm = source.getItemIdxAt(source.lastEvent.x, source.lastEvent.y);
                    }
                    if(itm != -1){
                        //we want to make sure we actually clicked on an item before decide what to do with it...BC

                        if (source.lastEvent != null && source.lastEvent.clicks >= 2) {
                            //Call open entity. If this is a Form, it will be opened; otherwise, the editor will launch...KB
                            m.openEntity();
                        }

                        //on single click of the group model we view all of that entity type...TD
                        else if (source.lastEvent != null && source.lastEvent.clicks == 1) {
                            m.viewAllPressed();
                        }
                    }

                    //clear the delete panel if it is up...BC
                    m.goBackClick()
                });

                scrollPan.add(zebra.layout.CENTER, gpList);
                generalPanel.add(zebra.layout.CENTER, scrollPan);
                rootPanel.add(zebra.layout.CENTER, generalPanel);
            }
        };

        /**
         * This function is assumed to be able to operate outside of the model context, but needs a reference to the model to operate.
         * @param modelObj {Object} A reference to the model context.
         */
        m.performSearch = function (modelObj) {
            var groupedListRef = modelObj.leftCanvas.refControls.groupedList = new zebra.data.GroupedListModel(),
                searchText = modelObj.searchAreaInput(),
                searchResults = modelObj.searchEntities(searchText),
                displayLimit = m.displayLimit;

            //Show recent items when the searchfield is empty..MD
            if (searchText.length == 0 && dvPinpoint.recentList.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'recent')) {
                //searchResults.recent = tools.sortComplex(dvPinpoint.recentList, "Definition.Name", true);
                searchResults.recent = dvPinpoint.recentList;
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('RECENT', searchResults.recent.length ));
                for (var i = 0, il = searchResults.recent.length ; i < il; i++) {
                    //select icon by entityType
                    var item = searchResults.recent[i];
                    if (item.clientProperties != null && item.clientProperties.entityType != null){
                        var typeIcon = 'propertyMini', name = "#"+item.Definition.Name;

                        switch (item.clientProperties.entityType) {

                            case app.dv.types.EntityTypes.View:
                                typeIcon = 'viewMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.RecordType:
                                typeIcon = 'recordMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.Style:
                                typeIcon = 'styleMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.Tag:
                                typeIcon = 'recordtypeicons/tagMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.ValueStatus:
                                typeIcon = 'statusMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.Package:
                                typeIcon = 'packageMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.Property:
                                typeIcon = 'propertiesMini';
                                name = item.Definition.Name;
                                break;
                            case app.dv.types.EntityTypes.SecurityGroup:
                                typeIcon = 'securityMini';
                                name = item.Definition.Name;
                                break;

                            case app.dv.types.EntityTypes.Action:
                            case app.dv.types.EntityTypes.Expression:
                            case app.dv.types.EntityTypes.Endpoint:
                            default:
                                typeIcon = 'function';
                                name = item.Definition.Metadata.Name;
                        }

                    }//otherwise remove it from the list
                    else {
                        //is it a label?
                        typeIcon = "propertiesMini";
                        name = item.Definition.Name;
                    }

                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(name, typeIcon, item));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (i == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }


            //Views -- forms
            if (searchResults.views.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'forms')) {
                searchResults.views = tools.sortComplex(searchResults.views, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('FORMS', searchResults.views.length));
                let viewIcon = app.dv.tools.getImagePanByName('viewMini', 15, 15);
                for (var i = 0, il = searchResults.views.length; i < il; i++) {
                    var item = searchResults.views[i];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'viewMini', item, viewIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (i == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //RecordTypes -- tables
            if (searchResults.recordTypes.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'tables')) {
                searchResults.recordTypes = tools.sortComplex(searchResults.recordTypes, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('TABLES', searchResults.recordTypes.length));
                let recordIcon = app.dv.tools.getImagePanByName('recordMini', 15, 15);
                for (var j = 0, jl = searchResults.recordTypes.length; j < jl; j++) {
                    var item = searchResults.recordTypes[j];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'recordMini', item, recordIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all..TD
                    if (j == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Styles
            if (searchResults.styles.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'styles')) {
                searchResults.styles = tools.sortComplex(searchResults.styles, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('STYLES', searchResults.styles.length));
                let styleIcon = app.dv.tools.getImagePanByName('styleMini', 15, 15);
                for (var k = 0, kl = searchResults.styles.length; k < kl; k++) {
                    var item = searchResults.styles[k];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'styleMini', item, styleIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (k == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Tags
            if (searchResults.tags.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'tags')) {
                searchResults.tags = tools.sortComplex(searchResults.tags, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('TAGS', searchResults.tags.length));
                let tagIcon = app.dv.tools.getImagePanByName('recordtypeicons/tagMini', 15, 15);
                for (var l = 0, ll = searchResults.tags.length; l < ll; l++) {
                    var item = searchResults.tags[l];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'recordtypeicons/tagMini', item, tagIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (l == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Statuses
            if (searchResults.statuses.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'statuses')) {
                searchResults.statuses = tools.sortComplex(searchResults.statuses, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('STATUSES', searchResults.statuses.length));
                let statusIcon = app.dv.tools.getImagePanByName('statusMini', 15, 15);
                for (var q = 0, ql = searchResults.statuses.length; q < ql; q++) {
                    var item = searchResults.statuses[q];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'statusMini', item, statusIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (q == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Packages
            if (searchResults.packages.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'packages')) {
                searchResults.packages = tools.sortComplex(searchResults.packages, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('PACKAGES', searchResults.packages.length));
                let packageIcon = app.dv.tools.getImagePanByName('packageMini', 15, 15);
                for (var n = 0, nl = searchResults.packages.length; n < nl; n++) {
                    var item = searchResults.packages[n];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'packageMini', item, packageIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (n == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Custom Expression Functions
            if (searchResults.customExpressions.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'custom functions')) {
                searchResults.customExpressions = tools.sortComplex(searchResults.customExpressions, "Definition.Metadata.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('CUSTOM FUNCTIONS', searchResults.customExpressions.length));
                let expressionIcon = app.dv.tools.getImagePanByName('function', 15, 15);
                for (var q = 0, ql = searchResults.customExpressions.length; q < ql; q++) {
                    var item = searchResults.customExpressions[q];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Metadata.Name, 'function', item, expressionIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (q == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Custom Actions
            if (searchResults.customActions.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'custom actions')) {
                searchResults.customActions = tools.sortComplex(searchResults.customActions, "Definition.Metadata.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('CUSTOM ACTIONS', searchResults.customActions.length));
                let actionIcon = app.dv.tools.getImagePanByName('function', 15, 15);
                for (var q = 0, ql = searchResults.customActions.length; q < ql; q++) {
                    var item = searchResults.customActions[q];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Metadata.Name, 'function', item, actionIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (q == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //#region Custom Endpoints
            if (searchResults.customEndpoints.length > 0 && (m.viewAllEntity == null || m.viewAllEntity === 'custom endpoints')) {
                searchResults.customEndpoints = tools.sortComplex(searchResults.customEndpoints, "Definition.Metadata.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('CUSTOM ENDPOINTS', searchResults.customEndpoints.length));
                let endpointIcon = app.dv.tools.getImagePanByName('function', 15, 15),
                    count = 0;
                searchResults.customEndpoints.some((item) => {
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Metadata.Name, 'function', item, endpointIcon));

                    //if this line is true, we have reached the display limit (top 5) stop now; unless we have a view all entity then show all.
                    return ++count >= displayLimit && m.viewAllEntity == null;
                });
            }
            //#endregion

            //Properties -- columns
            if (searchResults.properties.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'columns')) {
                searchResults.properties = tools.sortComplex(searchResults.properties, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('COLUMNS', searchResults.properties.length));
                let propertyIcon = app.dv.tools.getImagePanByName('propertiesMini', 15, 15);
                for (var o = 0, ol = searchResults.properties.length; o < ol; o++) {
                    var item = searchResults.properties[o];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'propertiesMini', item, propertyIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (o == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            //Security Groups
            if (searchResults.securityGroups.length > 0 && (m.viewAllEntity == null || m.viewAllEntity == 'security groups')) {
                searchResults.securityGroups = tools.sortComplex(searchResults.securityGroups, "Definition.Name", true);
                groupedListRef.add(new zebra.data.GroupedListModel.GroupModel('SECURITY GROUPS', searchResults.securityGroups.length));
                let securityIcon = app.dv.tools.getImagePanByName('securityMini', 15, 15);
                for (var p = 0, pl = searchResults.securityGroups.length; p < pl; p++) {
                    var item = searchResults.securityGroups[p];
                    groupedListRef.add(new zebra.data.GroupedListModel.ItemModel(item.Definition.Name, 'securityMini', item, securityIcon));

                    //we have reached the display limit (top 5) now stop unless we have a view all entity then show all...TD
                    if (p == displayLimit - 1 && m.viewAllEntity == null) {
                        break;
                    }
                }
            }

            modelObj.leftCanvas.refControls.gpList.setModel(groupedListRef);
            modelObj.leftCanvas.refControls.gpList.invalidate();
        };

        //Hide the search panel
        m.hide = function () {
            m.boundShowProperty(false);
            m.showLeftCont(false);
            m.showRightCont(false);
            m.showDeletePanel(false);
            m.showWhereUsed(false);
        };

        m.init = function(callback){
            m.callback = callback;
            return;
        };

        //Search through the left control and update as necessary based on the text
        m.searchList = function(data, event){
            if(event.stop == true){
                return;
            }
            var words = m.searchAreaInput();
            if(words != null && words.length > 0 || m.keepOpen() == true){
                m.showLeftCanvas();
                if (m.lastSearchEmpty == true) {
                    m.showLeftCont(false);
                }

                // This will allow the user to type quickly and not bog down the response. It will give a 50ms delay to the last keystroke.
                clearTimeout((m.timeoutHandler));
                m.timeoutHandler = setTimeout(function (src) {
                    clearTimeout((m.timeoutHandler));
                    src.performSearch(src);
                    if (m.leftCanvas.refControls.gpList.model.count() > 0) {
                        m.lastSearchEmpty = false;
                        m.showLeftCont(true);
                        m.showRightCont(true);
                        //0 will be the group header, 1 will be the first item.
                        m.leftCanvas.refControls.gpList.$select(1);
                        m.leftCanvas.refControls.gpList.position.setOffset(1);
                        setTimeout(function (src){
                            m.leftCanvas.refControls.gpList.vrp();
                        }, 10, m)
                    }
                    else{
                        m.lastSearchEmpty = true;
                        //no results;  hide both panels
                        m.showLeftCont(false);
                        m.showRightCont(false);
                    }
                }, 5, m);
                //we need to show the bottom left panel
                //perform the search.
            }
            else{
                m.showLeftCont(false);
                m.showRightCont(false);
                //we need to hide the bottom left panel
            }
        };

        //this function searches the cache for entity types and returns an object with entity array properties that match the criteria...TD
        m.searchEntities = function (filterTerms){
            if (Array.isArray(filterTerms) == false) {
                //deal with double quotes...TB
                var finalFilter = [];
                var newFilter = "";
                var nextQuote = false;
                filterTerms = filterTerms.split('"');
                //if the first string is empty, we start with a double quote...TB
                if(filterTerms[0] == ''){
                    nextQuote = true;
                    filterTerms.shift();
                }
                while(filterTerms.length > 0){
                    //two adjacent double quotes cause an empty string in the split
                    if(filterTerms[0] == ""){ nextQuote = false; }
                    else if(nextQuote == true){
                        finalFilter.push(filterTerms[0]);
                        nextQuote = false;
                    }
                    else{
                        newFilter = newFilter + filterTerms[0];
                        nextQuote = true;
                    }
                    filterTerms.shift();
                }

                //deal with spaces, making sure there are no empty strings...TB
                newFilter = newFilter.split(" ");
                newFilter = newFilter.filter(function (v) { return v !== '' });
                filterTerms = finalFilter.concat(newFilter);
            }

            var searchResults = {
                recent: [],
                views: [],
                recordTypes: [],
                styles: [],
                tags: [],
                statuses: [],
                packages: [],
                properties: [],
                securityGroups: [],
                customExpressions: [],
                customActions: [],
                customEndpoints: [],
                recentList: []
            };

            //recent Entities
            if (dvPinpoint.recentList.length > 0) {
                searchResults.recent = dvPinpoint.recentList.filter(function(recent){
                    if (recent != null || recent.Definition == null || recent.Definition.Name == null){
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }

            //search views
            searchResults.views = app.dv.cache.views.allViews.Values.filter(function(view){
                for(var i = 0; i < filterTerms.length; i++){
                    if (view.Definition == null || view.Definition.Name == null) {
                        return false;
                    }
                    if(view.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search record types
            searchResults.recordTypes = app.dv.cache.recordTypes.allRecordTypes.Values.filter(function(rt){
                for(var i = 0; i < filterTerms.length; i++){
                    if (rt.Definition == null || rt.Definition.Name == null) {
                        return false;
                    }
                    if(rt.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search styles
            searchResults.styles = app.dv.cache.styles.allStyles.Values.filter(function(style){
                for(var i = 0; i < filterTerms.length; i++){
                    if (style.Definition == null || style.Definition.Name == null) {
                        return false;
                    }
                    if(style.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search tags
            searchResults.tags = app.dv.cache.tags.allTags.Values.filter(function(tag){
                for(var i = 0; i < filterTerms.length; i++){
                    if (tag.Definition == null || tag.Definition.Name == null) {
                        return false;
                    }
                    if(tag.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search statuses
            searchResults.statuses = app.dv.cache.valueStatuses.allValueStatuses.Values.filter(function(status){
                for(var i = 0; i < filterTerms.length; i++){
                    if (status.Definition == null || status.Definition.Name == null) {
                        return false;
                    }
                    if(status.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search packages
            searchResults.packages = app.dv.cache.packages.allPackages.Values.filter(function(pkg){
                for(var i = 0; i < filterTerms.length; i++){
                    if (pkg.Definition == null || pkg.Definition.Name == null) {
                        return false;
                    }
                    if(pkg.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search properties
            searchResults.properties = app.dv.cache.properties.allProperties.Values.filter(function(property){
                for(var i = 0; i < filterTerms.length; i++){
                    if (property.Definition == null || property.Definition.Name == null) {
                        return false;
                    }
                    if(property.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search security groups
            searchResults.securityGroups = app.dv.cache.securityGroups.allSecurityGroups.Values.filter(function(securityGroup){
                for(var i = 0; i < filterTerms.length; i++){
                    if (securityGroup.Definition == null || securityGroup.Definition.Name == null) {
                        return false;
                    }
                    if(securityGroup.Definition.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search custom expressions
            searchResults.customExpressions = app.dv.cache.extensions.allExpressions.Values.filter(function(customExpression){
                for(var i = 0; i < filterTerms.length; i++){
                    if (customExpression.Definition == null || customExpression.Definition.Metadata == null || customExpression.Definition.Metadata.Name == null) {
                        return false;
                    }
                    if(customExpression.Definition.Metadata.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //search custom actions
            searchResults.customActions = app.dv.cache.extensions.allActions.Values.filter(function(customAction){
                for(var i = 0; i < filterTerms.length; i++){
                    if (customAction.Definition == null || customAction.Definition.Metadata == null || customAction.Definition.Metadata.Name == null) {
                        return false;
                    }
                    if(customAction.Definition.Metadata.Name.toLowerCase().indexOf(filterTerms[i].toLowerCase()) == -1){
                        return false;
                    }
                }
                return true;
            });

            //#region search custom endpoints
            searchResults.customEndpoints = app.dv.cache.extensions.allCustomEndpoints.Values.filter((customEndpoint) => {
                if (Array.isArray(filterTerms) && filterTerms.length > 0) {
                    if (customEndpoint.Definition == null
                        || customEndpoint.Definition.Metadata == null
                        || customEndpoint.Definition.Metadata.Name == null) {
                        // nothing to search; not found here.
                        return false;
                    }

                    // return if any term was "found" or not.
                    return filterTerms.some((term) => {
                        // if any of the terms are found in the defined user-readable name, it is "found".
                        return customEndpoint.Definition.Metadata.Name.toLowerCase().contains(term.toLowerCase());
                    });
                }
                return true;
            });
            //#endregion

            return searchResults;
        };

        //Set the controls on the right panel based on what the user selected on the left panel
        m.setRightPanel = function(selectedObj){
            if(selectedObj == null || selectedObj.Definition == null){
                return;
            }

            var entityType = selectedObj.clientProperties.entityType;

            m.titleLabel("Title");
            m.nameLabel("Name");
            m.hintLabel("Description");
            m.tagLabel("Tags");
            m.showDeleteIcon(false);
            m.showOpenIcon(false);
            m.showCloneIcon(false);

            //Update the name, definition, and description of everything...BC
            m.titleAreaInput(selectedObj.Definition.Name);
            m.nameAreaInput(selectedObj.Name);
            m.hintAreaInput(selectedObj.Definition.Description || selectedObj.Definition.Notes);
            m.rUIDLabel(selectedObj.UID);
            m.showTitle(true);
            m.showName(true);
            m.showHint(true);

            if (selectedObj.clientProperties && selectedObj.clientProperties.Tags) {
                m.showTags(true);
                let tags = "";
                selectedObj.clientProperties.Tags.Values.forEach((tag) => {
                    let tagElement = document.createElement('span');
                    tagElement.classList.add("entityTag");
                    let tagName = (tag.Definition && tag.Definition.Name) || tag.Name;
                    if (tagName != null) {
                        tagElement.innerText = tagName;
                        tags += tagElement.outerHTML;
                    }
                });
                m.tagsHTML(tags);
            }
            else {
                m.showTags(false);
            }

            switch(entityType){
                case app.dv.types.EntityTypes.View:
                    m.rIDLabel(selectedObj.ViewID);
                    m.rightContType("FORM");
                    m.showOpenIcon(true);
                    m.showDeleteIcon(true);
                    m.showCloneIcon(true);
                    break;
                case app.dv.types.EntityTypes.RecordType:
                    m.rIDLabel(selectedObj.RecordTypeID);
                    m.rightContType("TABLE");
                    m.showDeleteIcon(true);
                    break;
                case app.dv.types.EntityTypes.Style:
                    m.rIDLabel(selectedObj.StyleID);
                    m.rightContType("STYLE");
                    m.showDeleteIcon(true);
                    m.showCloneIcon(true);
                    break;
                case app.dv.types.EntityTypes.Tag:
                    m.rIDLabel(selectedObj.TagID);
                    m.rightContType("TAG");
                    m.showDeleteIcon(true);
                    break;
                case app.dv.types.EntityTypes.ValueStatus:
                    m.rIDLabel(selectedObj.ValueStatusID);
                    m.rightContType("STATUS");
                    break;
                case app.dv.types.EntityTypes.Package:
                    m.rightContType("PACKAGE");
                    m.rIDLabel(selectedObj.PackageID);
                    m.showDeleteIcon(true);
                    break;
                case app.dv.types.EntityTypes.Property:
                    m.rightContType("COLUMN");
                    m.showDeleteIcon(true);
                    m.rIDLabel(selectedObj.PropertyID);
                    break;
                case app.dv.types.EntityTypes.SecurityGroup:
                    m.rightContType("SECURITY GROUP");
                    m.rIDLabel(selectedObj.SecurityGroupID);
                    break;
                case app.dv.types.EntityTypes.Expression:
                    m.titleLabel("Syntax");
                    m.nameLabel("Keywords");
                    m.hintLabel("Description");
                    m.titleAreaInput(selectedObj.Definition.Metadata.Syntax);
                    m.nameAreaInput(selectedObj.Definition.Metadata.Keywords);
                    m.hintAreaInput(selectedObj.Definition.Metadata.Description || selectedObj.Definition.Metadata.Notes);
                    m.rightContType("CUSTOM FUNCTION");
                    m.rIDLabel(selectedObj.ExtensionID);
                    break;
                case app.dv.types.EntityTypes.Action:
                    m.titleLabel("Category");
                    m.nameLabel("Name");
                    m.hintLabel("Description");
                    m.titleAreaInput(selectedObj.Definition.Metadata.Category);
                    m.nameAreaInput(selectedObj.Definition.Metadata.Name);
                    m.hintAreaInput(selectedObj.Definition.Metadata.Description || selectedObj.Definition.Metadata.Notes);
                    m.rightContType("CUSTOM ACTION");
                    m.rIDLabel(selectedObj.ExtensionID);
                    m.showDeleteIcon(true);
                    m.showCloneIcon(true);
                    break;

                case app.dv.types.EntityTypes.Endpoint:
                    // Endpoints do not store a title (only Name) so hide it...AM
                    m.showTitle(false);
                    m.nameLabel("Name");
                    m.hintLabel("Description");
                    m.nameAreaInput(selectedObj.Definition.Metadata.Name);
                    m.hintAreaInput(selectedObj.Definition.Metadata.Description || selectedObj.Definition.Metadata.Notes);
                    m.rightContType("CUSTOM ENDPOINT");
                    m.rIDLabel(selectedObj.ExtensionID);
                    m.showDeleteIcon(true);
                    break;

                default:
                    m.rIDLabel("");
            }
            m.showRightCont(true);
            m.leftCanvas.refControls.scrollPan.vrp();
        }

        //Get rid of the search list
        m.dispose = function(){
            if (m.showTimeout != 0) {
                clearTimeout(m.showTimeout);
            }
            if (listening == true) {
                if (window.removeEventListener) {
                    window.removeEventListener("resize", m.htmlWindowResize);
                }
                else {
                    window.detachEvent("resize", m.htmlWindowResize);
                }
                listening = false;
            }
            m.hide();
        };

        /*close the pinpoint search
        *@param clear -- if true, clear the search text and don't save it for later.
        *it is only true if we open or edit something.
        * */
        m.checkClose = function(clear){
            if(clear === true){
                dvPinpoint.searchText = "";
                m.showLeftCont(false);
                m.showRightCont(false);
            }
            else{
                //Set the text for when we open it back up later...BC
                dvPinpoint.searchText = m.searchAreaInput();
            }
            m.hide();
            m.callback();
        };

        return m;
    };

    dvPinpoint.register = function () {
        dvPinpoint.componentName = app.dv.appSpace.id + "-dvPinpoint";
        if (!ko.components.isRegistered(dvPinpoint.componentName))
            ko.components.register(dvPinpoint.componentName, dvPinpoint.component)
    };

    return dvPinpoint;
});
